import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import CommerceOnly from '/src/_includes/commerce-only.md';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <CommerceOnly mdxType="CommerceOnly" />
    <h1 {...{
      "id": "addpurchaseordercomment-mutation"
    }}>{`addPurchaseOrderComment mutation`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`addPurchaseOrderComment`}</inlineCode>{` mutation adds a comment to the specified purchase order. The response contains details about the comment.`}</p>
    <h2 {...{
      "id": "syntax"
    }}>{`Syntax`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation {
  addPurchaseOrderComment(
    input: AddPurchaseOrderCommentInput!
  ) {
      AddPurchaseOrderCommentOutput
  }
}
`}</code></pre>
    <h2 {...{
      "id": "reference"
    }}>{`Reference`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#mutation-addPurchaseOrderComment"
      }}><inlineCode parentName="a">{`addPurchaseOrderComment`}</inlineCode></a>{` reference provides detailed information about the types and fields defined in this mutation.`}</p>
    <h2 {...{
      "id": "example-usage"
    }}>{`Example usage`}</h2>
    <p>{`The following example adds a comment to the purchase order.`}</p>
    <p><strong parentName="p">{`Request:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation {
  addPurchaseOrderComment(
      input: {
        purchase_order_uid: "MQ==",
        comment: "Looks good to me"
      },
    ) {
    comment {
        uid
        author {
            firstname
            lastname
            email
        }
        text
    }
  }
}
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "data": {
    "addPurchaseOrderComment": {
      "comment": {
        "uid": "Mw==",
        "author": {
          "firstname": "John",
          "lastname": "Doe",
          "email": "john.doe@example.com"
        },
        "text": "Looks good to me."
      }
    }
  }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      